export default {
    loadEventData({commit, dispatch, rootState, state}, query) {
        const eventId = query.event
        if(state.event && state.event[eventId]) {
            if(JSON.stringify(query) == JSON.stringify(state.event[eventId].query)) return
        }
        let queryCon = {}
        for(let key in query) {
            if(query[key]) queryCon[key] = query[key]
        }
        commit('startLoadingEvent', eventId)
        return dispatch('get', {
            url: '/provider/' + rootState.provider.id + '/engagement',
            query: {event: queryCon.event}
        }, { root: true})
        .then(response => {
            let eventData = {...response, query}
            commit('finishLoadingEvent', eventId)
            commit('setEventData', {eventData, eventId})
        })
        .catch(error => {
            commit('finishLoadingEvent', eventId)
            throw error
        })
    }
}
